import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/storage'
import 'firebase/compat/auth'
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBMv8SUa0T-bboFiIQ42mMPGiOa_LUkpmQ",
  authDomain: "caribbean-ems.firebaseapp.com",
  projectId: "caribbean-ems",
  storageBucket: "caribbean-ems.firebasestorage.app",
  messagingSenderId: "780351915238",
  appId: "1:780351915238:web:f54910c0e2a842e6e7a727",
  measurementId: "G-RBF9NDFQSG"
})
const db = firebaseApp.firestore()
export const storage = firebase.storage()
export const auth = firebase.auth()
export default db